import { BaseModel } from "@blue-chip/core";

export default class Person extends BaseModel {}
